import { normalizeRouteName } from './context.js';
import {
  beginOrResumeCoreFlow,
  completeCoreFlow,
  markCoreFlowStep
} from './flow.js';
import { startPageMonitor } from './page.js';

export {
  normalizeApiName,
  normalizeRouteName,
  resolveDeviceClass,
  resolveOsFamily,
  resolveRuntimeContext,
  RUNTIME_SCENE,
  shouldSample
} from './context.js';
export { countMetric, recordDistribution } from './metrics.js';
export {
  beginOrResumeCoreFlow,
  completeCoreFlow,
  getCoreFlowState,
  markCoreFlowStep
} from './flow.js';
export {
  classifyApiError,
  classifyApiResponse,
  createApiObservation,
  finishApiObservation,
  shouldCreateAutoHttpSpanForRequest
} from './api.js';
export { recordWebviewReloadIfNeeded, startPageMonitor } from './page.js';

/**
 * 初始化稳定性监控。
 * @param {Object} router - Vue Router 实例。
 * @returns {Function} 停止监控函数。
 */
export function initStabilityMonitoring(router) {
  const stopPageMonitor = startPageMonitor(router);
  // Router 不存在或不支持 afterEach 时只返回页面监控清理函数。
  if (!router || typeof router.afterEach !== 'function') {
    return stopPageMonitor;
  }
  router.afterEach((to) => {
    const routeName = normalizeRouteName(to);
    // 进入首页时创建或恢复核心流程。
    if (routeName === 'home') {
      beginOrResumeCoreFlow();
    }
    // 进入添加照片页时标记核心流程 addPhoto 阶段。
    if (routeName === 'addPhoto') {
      markCoreFlowStep('add_photo');
    }
  });
  return stopPageMonitor;
}

/**
 * 标记核心流程已进入选图处理。
 * @returns {void}
 */
export function markCoreFlowPhotoSelected() {
  markCoreFlowStep('photo_selected');
}

/**
 * 标记核心流程完成。
 * @returns {boolean} 是否记录完成。
 */
export function markCoreFlowCompleted() {
  return completeCoreFlow();
}
